/*
  Per person line support. Loaded on every page from layout/theme.liquid.

  1. Product page, quick view and cards: the line is rendered in Liquid by
     snippets/per-person.liquid straight after the price. If the theme
     changes the price in place (variant change), this recalculates the
     figure from the hidden .target-price value (in pence) next to it.

  2. Cart drawer and cart page: fetches sections/per-person-cart.liquid,
     which works out each cart line's figure in Liquid, then adds the line
     inside each line's price block. Re-applied whenever the cart redraws.
*/
(function () {
  if (window.perPersonReady) return;
  window.perPersonReady = true;

  /* Price blocks inside each cart row that get the line */
  var CART_PRICE_SELECTORS = [
    '.product-info-column-1 > .price', /* cart drawer, small screens */
    '.product-info-column-2 > .price', /* cart drawer, large screens */
    'td.col-start-2 div.price', /* cart page, under the product title (small screens) */
    'td.md\\:w-2\\/12 > .price' /* cart page, price column (large screens) */
  ];

  function formatLike(sample, pence) {
    return sample.replace(/[\d.,]+/, (pence / 100).toFixed(2));
  }

  /* 1. Lines rendered under product and card prices */
  function refreshPriceLines() {
    var lines = document.querySelectorAll('.per-person[data-people]');
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var people = parseInt(line.getAttribute('data-people'), 10) || 0;
      var box = line.previousElementSibling;
      var target = box && box.querySelector('.target-price');
      var amountEl = line.querySelector('.per-person__amount');
      if (!target || !amountEl || people < 2) continue;
      var pence = parseInt(String(target.textContent).replace(/[^\d]/g, ''), 10) || 0;
      if (!pence) continue;
      var text = formatLike(amountEl.textContent, Math.round(pence / people));
      if (text !== amountEl.textContent) amountEl.textContent = text;
    }
  }

  /* 2. Cart drawer and cart page */
  var cartData = {};
  var cartSignature = null;
  var cartLoading = false;
  var cartFailures = 0;

  function cartAnchors() {
    return document.querySelectorAll('[id^="LineItemError-"]');
  }

  function loadCartData(signature) {
    if (cartLoading) return;
    cartLoading = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?section_id=per-person-cart', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var script = doc.querySelector('[data-per-person-cart]');
        if (!script) throw new Error('per-person-cart section missing');
        cartData = JSON.parse(script.textContent);
        cartSignature = signature;
        cartFailures = 0;
      })
      .catch(function () {
        /* Retried straight away, up to three attempts in a row */
        cartFailures += 1;
        if (cartFailures >= 3) {
          cartData = {};
          cartSignature = signature;
        }
      })
      .then(function () {
        cartLoading = false;
        queue();
      });
  }

  function makeLine() {
    var line = document.createElement('p');
    line.className = 'per-person per-person--cart';
    line.setAttribute('data-nosnippet', '');
    var amount = document.createElement('span');
    amount.className = 'per-person__amount';
    line.appendChild(amount);
    line.appendChild(document.createTextNode(' per person'));
    return line;
  }

  function refreshCartLines() {
    var anchors = cartAnchors();
    if (!anchors.length) return;

    var keys = [];
    for (var i = 0; i < anchors.length; i++) keys.push(anchors[i].id.slice(14));
    var signature = keys.slice().sort().join('|');
    if (signature !== cartSignature) {
      loadCartData(signature);
      return;
    }

    for (var j = 0; j < anchors.length; j++) {
      var key = anchors[j].id.slice(14);
      var amount = cartData[key];
      var row = anchors[j].closest('tr.cart-item, .cart-item');
      if (!row) continue;

      for (var s = 0; s < CART_PRICE_SELECTORS.length; s++) {
        var boxes = row.querySelectorAll(CART_PRICE_SELECTORS[s]);
        for (var b = 0; b < boxes.length; b++) {
          var box = boxes[b];
          var line = box.querySelector('.per-person--cart');
          if (!amount) {
            if (line) line.remove();
            continue;
          }
          if (!line) {
            line = makeLine();
            box.appendChild(line);
          }
          var span = line.querySelector('.per-person__amount');
          if (span.textContent !== amount) span.textContent = amount;
        }
      }
    }
  }

  /* Run shortly after any change to the page, batching bursts of changes */
  var queued = false;

  function refresh() {
    queued = false;
    refreshPriceLines();
    refreshCartLines();
  }

  function queue() {
    if (queued) return;
    queued = true;
    window.setTimeout(refresh, 40);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queue);
  } else {
    queue();
  }

  new MutationObserver(queue).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
